import {SwapVert} from "@mui/icons-material";
import {Card, Divider, IconButton, Stack, Typography} from "@mui/material";
import {useAuthState} from "react-firebase-hooks/auth";
import type {BasePlaces} from "../../firebase/index.js";
import {auth, PlaceModel} from "../../firebase/index.js";
import {useInMemoryTrip} from "../../redux/InMemoryTripReducer.js";
import {red_900} from "../../reusables/js/APXTheme.js";
import {useAnchorSelectorBSL} from "./AnchorSelectorBSL.jsx";
import SummaryAnchorSelectorBSL from "./SummaryAnchorSelectorBSL.jsx";


export type ItinerarySummaryLayoutProps = {
	  dateKey: string;
	  basePlaces: BasePlaces;
}


export default function ItinerarySummaryLayout({dateKey, basePlaces}: ItinerarySummaryLayoutProps) {
	  const {showAnchorSelectorBottomSheet, setShowAnchorSelectorBottomSheet} = useAnchorSelectorBSL();
	  const inMemoryTrip = useInMemoryTrip();
	  const uid = useAuthState(auth)[0]?.uid;
	  return (
				 <>
						<Card variant={"outlined"} sx={{my: 1, borderColor: red_900, opacity: inMemoryTrip.isCompleted ? 0.75 : 1}}>
							  <Stack direction={"row"} alignItems={"stretch"}>
									 <Stack justifyContent={"center"} sx={{p: 2, width: "10%", backgroundColor: red_900}}>
											<Typography align={"center"} variant={"h6"}>
												  {new Date(Number(dateKey)).toLocaleDateString("en-GB", {day: "numeric", month: "short"})}
											</Typography>
									 </Stack>
									 <Stack justifyContent={"center"} sx={{p: 1, width: "100%"}}>
											{
												  Object.entries(basePlaces).map(([placeKey, place: PlaceModel]) => (
															 <Typography key={placeKey} variant={"body1"}>{place.name}</Typography>
												  ))
											}
											<Divider sx={{my: 1}}/>
											{
												  Object.entries(basePlaces).map(([placeKey, place: PlaceModel]) => (
															 <Typography key={placeKey} variant={"body2"}>{place.note}</Typography>
												  ))
											}
									 </Stack>
									 <Stack justifyContent={"center"} sx={{py: 0, backgroundColor: red_900}}>
											<IconButton disabled={inMemoryTrip.isCompleted} sx={{p: 0, color: "white"}} onClick={() => setShowAnchorSelectorBottomSheet(true)}>
												  <SwapVert/>
											</IconButton>
											{
													  showAnchorSelectorBottomSheet &&
													  <SummaryAnchorSelectorBSL uid={uid} onClose={() => setShowAnchorSelectorBottomSheet(false)} dateKey={dateKey} basePlaces={basePlaces}/>
											}
									 </Stack>
							  </Stack>
						</Card>
				 </>
	  );
}